import React, {useState} from "react";
import {ClipboardIcon, ShareIcon} from "@shopify/polaris-icons";
import {Icon} from "@shopify/polaris";
import { useTranslation } from 'react-i18next';
const ShareBox = ({setShowShare, shopDomain, crewCartToken, crewCart, settings}) => {
    const [copied, setCopied] = useState(false);
    const { t } = useTranslation();


    const shareMobile = async (e) => {
        // Ensure we have a user gesture
        e.preventDefault();

        if (!navigator.share) {
            console.log('Web Share not supported on this browser');
            return;
        }

        try {
            // Check if we're in a secure context
            if (!window.isSecureContext) {
                throw new Error('Web Share requires HTTPS');
            }

            const shareData = {
                title: crewCart?.name || 'Crewcart Shopping',
                text: 'Join my Crewcart!',
                url: `https://${shopDomain}${settings?.custom_invite_url}/?crew_cart=${crewCartToken}`
            };

            console.log({shareData});

            await navigator.share(shareData);
            console.log('Successfully shared');
            setShowShare(false);
        } catch (error) {
            if (error.name === 'NotAllowedError') {
                // Fallback to clipboard
                navigator.clipboard.writeText(`https://${shopDomain}${settings?.custom_invite_url}/?crew_cart=${crewCartToken}`);
                setCopied(true);
                setTimeout(() => {
                    setCopied(false);
                }, 1000);
            }
            console.log('Error sharing:', error);
        }
    };
    return (
        <div className={"share-crewcart"} style={{padding: "10px", marginBottom: "10px"}}>
            <style>
                {`
                .share-crewcart .url-share{
                    text-decoration:underline;
                }
                .share-crewcart .url-share, .share-crewcart .copy-button{
                    background: #ddd;
                }
                .share-crewcart .copy-button{
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-width: 50px;
                    height: 38px;
                    padding:0;
                    margin:0;
                    border-top-left-radius:0;
                    border-bottom-left-radius:0;
                }
                .copy-button-icon {
                    align-items: center;
                    justify-content: center;
                    width:22px;
                    height:22px;
                }
                .input-group {
                    display: flex;
                    gap:3px;
                }
                `}
            </style>
            <>{t('cartItems.shareDescription')}</>
            <div className="input-group" style={{marginTop: "10px"}}>
                <input
                    autoComplete="off"
                    type="text"
                    className="form-control url-share"
                    placeholder="loading.."
                    value={`https://${shopDomain}${settings?.custom_invite_url}/?crew_cart=${crewCartToken}`}
                    readOnly
                />
                <button
                    className="btn btn-primary copy-button"
                    type="button"
                    onClick={async () => {
                        navigator.clipboard.writeText(
                            `https://${shopDomain}${settings?.custom_invite_url}/?crew_cart=${crewCartToken}`
                        )
                        setCopied(true);
                        await setTimeout(() => {
                            setCopied(false);
                            setShowShare(false);
                        }, 1000);
                    }}
                >
                    {copied ? t('cartItems.copied') : (
                        <div className="copy-button-icon">
                            <Icon source={ClipboardIcon} tone="base"/>
                        </div>
                    )}
                </button>
            </div><br />
            {navigator.share ? (
                <button
                    className="btn-primary-crewcart"
                    onClick={shareMobile}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        justifyContent: 'center'
                    }}
                >
                    <Icon source={ShareIcon} tone="base" />
                    <span>{t('cartItems.shareBox')}</span>
                </button>
            ) : null}
        </div>
    );
}

export default ShareBox;
